import { useEffect, useState } from "react";
import {
  ArrowRightLineIcon,
  GlobeMiniIcon,
  MailMiniIcon,
  MinusMiniIcon,
  PlusMiniIcon,
} from "@/components/SVGComponents/MemberIcons";
import Loader from "@/components/Loader/Loader";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { fetchFaqs } from "@/store/slices/FaqSlice";
import styles from "./HelpCentre.module.scss";

const SUPPORT_ACTIONS = [
  {
    title: "Get a Mobile App",
    icon: GlobeMiniIcon,
  },
  {
    title: "Send us email",
    icon: MailMiniIcon,
  },
] as const;

const HelpCentre = () => {
  const dispatch = useAppDispatch();
  const { faqs, isLoading, error } = useAppSelector((state) => state.faq);
  const [openItem, setOpenItem] = useState(0);

  useEffect(() => {
    dispatch(fetchFaqs());
  }, [dispatch]);

  return (
    <section className={styles.page}>
      <div className={styles.orbLeft} />
      <div className={styles.orbRight} />
      <div className={styles.dotsRight} />

      <div className={styles.inner}>
        <header className={styles.header}>
          <h1>Help Centre</h1>
          <p>
            Didn’t find the answers you are looking for?
            <br />
            Contact our support team!
          </p>
        </header>

        <div className={styles.supportGrid}>
          {SUPPORT_ACTIONS.map(({ icon: Icon, title }) => (
            <button className={styles.supportCard} key={title} type="button">
              <div className={styles.supportCardLeft}>
                <span className={styles.supportIcon}>
                  <Icon />
                </span>
                <span className={styles.supportTitle}>{title}</span>
              </div>

              <ArrowRightLineIcon className={styles.supportArrow} />
            </button>
          ))}
        </div>

        <div className={styles.faqSectionTitle}>
          <h2>FAQ</h2>
        </div>

        {isLoading ? (
          <div className={styles.faqCard}>
            <Loader fullscreen={false} size={100} />
          </div>
        ) : error ? (
          <div className={styles.faqCard}>
            <p className={styles.errorMessage}>{error}</p>
          </div>
        ) : faqs.length > 0 ? (
          <div className={styles.faqCard}>
            {faqs.map((item, index) => {
              const isOpen = openItem === index;

              return (
                <div className={styles.faqItem} key={`${item.question}-${index}`}>
                  <button
                    className={styles.faqTrigger}
                    onClick={() => setOpenItem(isOpen ? -1 : index)}
                    type="button"
                  >
                    <span>{item.question}</span>
                    {isOpen ? (
                      <MinusMiniIcon className={styles.faqToggle} />
                    ) : (
                      <PlusMiniIcon className={styles.faqToggle} />
                    )}
                  </button>

                  {isOpen ? <p className={styles.faqAnswer}>{item.answer}</p> : null}
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.faqCard}>
            <p>No FAQs available at the moment.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default HelpCentre;
